export enum RoleEnum {
  SUPER_ADMIN = "super_admin",
  TEACHER_ADMIN = "teacher_admin",
  ADMIN = "admin",
  STUDENT = "student",
  TEACHER = "teacher",
  PARENT = "parent",
}

export enum NotificationAudienceEnum {
  STUDENT = "student",
  TEACHER_ADMIN = "teacher_admin",
  TEACHER = "teacher",
  PARENT = "parent",
  PARENT_NO_PURCHASE = "parent_no_purchase",
  STUDENT_NO_PURCHASE = "student_no_purchase",
}
